import { render, staticRenderFns } from "./ExploreTopicTags.vue?vue&type=template&id=3c038fef&scoped=true&"
import script from "./ExploreTopicTags.vue?vue&type=script&lang=js&"
export * from "./ExploreTopicTags.vue?vue&type=script&lang=js&"
import style0 from "./ExploreTopicTags.vue?vue&type=style&index=0&id=3c038fef&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3c038fef",
  null
  
)

export default component.exports